<mat-card class="example-card">
  <mat-card-content>
    <mat-toolbar color="primary">Catégories</mat-toolbar>
    <ng-template #attente>
      <br>
      <!-- <mat-progress-bar mode="indeterminate"></mat-progress-bar> -->
    </ng-template>
    <div *ngIf="enregistrementTerminer;else attente"></div>
    <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="12px" fxLayoutAlign="flex-start">
      <div fxFlex="0 1 calc(45% - 10px)" fxFlex.lt-md="0 1 calc(36% - 10px)" fxFlex.lt-sm="100%">
        <mat-card class="example-card">
          <mat-card-header>
            <mat-card-title>Liste catégories</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <app-show-tree-doc [param_code]="param_code" [File_Type]="'collaborateur'" [typeTrs]="'2'">
            </app-show-tree-doc>
          </mat-card-content>
        </mat-card>
      </div>
      <div>
        <mat-card class="example-card">
          <mat-card-header>
            <mat-card-title>Détails catégories</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <form class="example-form" #f="ngForm">
              <div fxLayout="row">
                <mat-form-field style="width:250px ;margin-right: 10px">
                  <input [disabled]="disabled" matInput name="categorie_Model" [matAutocomplete]="categorieModel"
                    (input)="oncategorieModelValuechange($event)" #categorie_Model="ngModel"
                    [(ngModel)]="categorieSelected" placeholder="Catégories">
                </mat-form-field>
                <div *ngIf="lastItemSelected" class="flex-col">
                  <div class="flexCenter">
                    <mat-checkbox *ngIf="Statuts == 0"
                      style="width:50px;display: flex; justify-content: center;align-items: center;"
                      (change)="onBlurStatuts(1)" [ngModel]="false" name="id4"></mat-checkbox>
                    <mat-checkbox *ngIf="Statuts == 1"
                      style="width:50px;display: flex; justify-content: center;align-items: center;"
                      (change)="onBlurStatuts(0)" [ngModel]="true" name="id5"></mat-checkbox>
                  </div>
                  <span class="flexCenter">(1)</span>
                </div>
                <span *ngIf="lastItemSelected" style="cursor: pointer"
                  (click)="importer('input_280_580'+lastItemSelected )">
                  <img [id]="'280_580'+ lastItemSelected"
                    [src]="(useDataBaseToSaveImage == 1? '' : (base_url +'images/')) + mainCat.ecArtCat[0].categorie_Image"
                    onerror="src='assets/imageError.png'" width="30px" height="60px">
                  <input [id]="'input_280_580'+ lastItemSelected" type="file" value="importer" style="display:none;"
                    (change)="onChangeImagefile($event,lastItemSelected,'280','580')">
                </span>
                <!-- <label *ngIf="footerStatuts == 1 ||footerStatuts ==0 " for="">Footer :</label> -->
                <div *ngIf="lastItemSelected" class="flex-col">
                  <div class="flexCenter">
                    <mat-checkbox *ngIf="footerStatuts == 0"
                      style="width:50px;display: flex; justify-content: center;align-items: center;"
                      (change)="onBlurMainCat(1)" [ngModel]="false" name="id1"></mat-checkbox>
                    <mat-checkbox *ngIf="footerStatuts == 1"
                      style="width:50px;display: flex; justify-content: center;align-items: center;"
                      (change)="onBlurMainCat(0)" [ngModel]="true" name="id2"></mat-checkbox>
                  </div>
                  <span class="flexCenter">(2)</span>
                </div>
                <mat-autocomplete #categorieModel="matAutocomplete" [displayWith]="setTextInput"
                  (optionSelected)="categorieModelSelected($event)">
                  <mat-option *ngFor="let option of categories" [value]="option">
                    {{option.categorie_Text |  textPipe : 'capitalize'}}
                  </mat-option>
                </mat-autocomplete>
                <button *ngIf="lastItemSelected" matTooltip="Supprimer" mat-icon-button
                  [disabled]="!enregistrementTerminer" (click)="supprimerImage(mainCat.ecArtCat[0])" color="primary">
                  <mat-icon>delete</mat-icon>
                </button>
                <div class="button-row">
                  <button type="submit" (click)="afficher()" [disabled]="disabled" class="bet_time" mat-raised-button
                    color="primary">Afficher</button>
                </div>
              </div>
              <mat-form-field *ngIf="lastItemSelected" style="width: 40%;margin-left: 5px;">
                <textarea matInput [(ngModel)]="setCategorie_Description" name="Categorie Description"
                  (blur)="SaveDescription()" placeholder="Description" style="margin-left: 10px; "></textarea>
              </mat-form-field>
              <div class="flex-col-start" *ngIf="lastItemSelected">
                <span style="color: red;"> (1) : Afficher la catégorie dans le menu</span>
                <span style="color: red;"> (2) : Afficher la catégorie dans le pied de page </span>
              </div>
            </form>

            <!-- <div fxLayout="row" fxLayoutAlign="space-between none" >
                    <mat-form-field>
                        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                    </mat-form-field>                    
                </div> -->
            <div class="example-table-container">
              <table id="tablecategories" mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="categorie_Code">
                  <th mat-header-cell *matHeaderCellDef>Code</th>
                  <td mat-cell *matCellDef="let element">
                    {{element.categorie_Code}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="categorie_Text">
                  <th mat-header-cell *matHeaderCellDef> Texte </th>
                  <td mat-cell *matCellDef="let element">
                    {{element.categorie_Text |  textPipe : 'capitalize'}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="categorie_Order">
                  <th mat-header-cell *matHeaderCellDef> Order </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-form-field style="width: 50px" class="example-full-width">
                      <input matInput (blur)="onBlur(element,false)" [(ngModel)]="element.categorie_Order" type="number"
                        style="width: 50px" [name]="'categorieText2'+element.categorie_Code">
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="categorie_Active">
                  <th mat-header-cell *matHeaderCellDef> Active </th>
                  <td mat-cell *matCellDef="let element" style="width: 50px">

                    <mat-checkbox *ngIf="element.categorie_Statut == 1" [name]="'categorieText3'+element.categorie_Code"
                      (change)="onBlur(element,true)" [ngModel]="true"></mat-checkbox>
                    <mat-checkbox *ngIf="element.categorie_Statut == 0" [name]="'categorieText3'+element.categorie_Code"
                      (change)="onBlur(element,true)" [ngModel]="false"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="categorie_Image">
                  <th mat-header-cell *matHeaderCellDef> Image</th>
                  <td mat-cell *matCellDef="let element" style="width: 50px">
                    <span style="cursor: pointer" (click)="importer('input_280_580'+ element.categorie_Code)">
                      <img [id]="'280_580'+ element.categorie_Code"
                        [src]="(useDataBaseToSaveImage == 1? '' : (base_url +'images/')) + element.categorie_Image"
                        onerror="src='assets/imageError.png'" width="30px" height="60px">
                      <input [id]="'input_280_580'+ element.categorie_Code" type="file" value="importer"
                        style="display:none;" (change)="onChangeImagefile($event,element.categorie_Code,'280','580')">
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="categorie_Footer_Active">
                  <th mat-header-cell *matHeaderCellDef> Footer</th>
                  <td mat-cell *matCellDef="let element">

                    <mat-checkbox *ngIf="element.categorie_StatutFooter == 1"
                      [name]="'categorieText3'+element.categorie_Code" (change)="onBlurFooter(element,1)"
                      [ngModel]="true"></mat-checkbox>
                    <mat-checkbox *ngIf="element.categorie_StatutFooter == 0"
                      [name]="'categorieText4'+element.categorie_Code" (change)="onBlurFooter(element,0)"
                      [ngModel]="false"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="SuppremerImage">
                  <th mat-header-cell *matHeaderCellDef> SuppremerImage</th>
                  <td mat-cell *matCellDef="let element">
                    <button matTooltip="Supprimer" mat-icon-button [disabled]="!enregistrementTerminer"
                      (click)="supprimerImage(element)" color="primary">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <!-- <ng-container matColumnDef="categorie_Image_580_580_1">
                  <th mat-header-cell *matHeaderCellDef> Image C </th>
                  <td mat-cell *matCellDef="let element">
                    <span style="cursor: pointer" (click)="importer('input_580_580'+ element.categorie_Code)">
                      <img [id]="'580_580'+ element.categorie_Code" [src]="element.File_Content_580_580_1" width="60px"
                        height="60px">
                      <input [id]="'input_580_580'+ element.categorie_Code" type="file" value="importer"
                        style="display:none;" (change)="onChangeImagefile($event,element.categorie_Code,'580','580')">
                    </span>
                  </td>
                </ng-container> -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow($event,row)"></tr>
              </table>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </mat-card-content>
</mat-card>
